// @flow
// moved to separate file in order to be able to test window.location assignment properly
export default (newLocation: string): void => {
  window.location = newLocation
}
